import api from '../api/axios';

export const getTlHome = (id) => api.get(`/TlHome/${id}`).then((r) => r.data);
export const getTeamRequirementsCount = (userId) => api.get(`/getTeamRequirementsCount/${userId}`).then((r) => r.data);
export const getRequirementsCandidatesCount = (recruiterId, userId) => api.get(`/getRequirementsCandidatesCount/${recruiterId}/${userId}`).then((r) => r.data);
export const getRequirementDetailsWithAssignedUsers = (userId, scope = 'all') => (
  api.get(`/requirementDetailsWithAssignedUsers/${userId}`, { params: { scope } }).then((r) => r.data)
);
